module.exports = __webpack_public_path__ + "d638b5962cd1f15e843b40ad0aef944e.png";